import { render, staticRenderFns } from "./OwnerSettings.vue?vue&type=template&id=476c3599&scoped=true"
import script from "./OwnerSettings.vue?vue&type=script&lang=js"
export * from "./OwnerSettings.vue?vue&type=script&lang=js"
import style0 from "./OwnerSettings.vue?vue&type=style&index=0&id=476c3599&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476c3599",
  null
  
)

export default component.exports